import ChevronDownIcon from 'components/icons/ChevronDown';
import React, { FC, useReducer, useRef } from 'react';
import styled from 'styled-components';

const ColumnTitle = styled.div`
  cursor: pointer;
  color: var(--gray-700);
  font-weight: 500;
  font-size: 1.2rem;
  display: flex;
  justify-content: space-between;
  stroke: var(--gray-500);
  & > div {
    transform: rotate(0deg);
    transition: 0.2s;
  }
  .open {
    transform: rotate(180deg);
  }
`;

const List = styled.div`
  margin-top: 1rem;
  margin-left: 2rem;
`;

const DropDownSelectorContainer = styled.div`
  width: 100%;
  max-width: 70rem;
  align-self: center;
  border-radius: 0.5rem;
  border: 1px solid var(--gray-300);
  padding: 1.5rem;
`;

type DropDownSelectorProps = {
  title: string | JSX.Element;
};
export const DropDownSelector: FC<DropDownSelectorProps> = ({
  title,
  children,
}) => {
  const [open, switchOpen] = useReducer((p) => !p, false);
  const list = useRef<HTMLDivElement>(null);

  return (
    <DropDownSelectorContainer>
      <ColumnTitle onClick={switchOpen}>
        {title}
        <div className={open ? 'open' : ''}>
          <ChevronDownIcon />
        </div>
      </ColumnTitle>
      <div
        style={{
          overflow: 'hidden',
          transition: '.2s',
          // height: open ? list.current?.clientHeight || 'auto' : 0,
          height: open ? 'auto' : 0,
        }}
      >
        <List ref={list}>{children}</List>
      </div>
    </DropDownSelectorContainer>
  );
};
